import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { stepToUrl } from '../../../shared/onboardingUtils';
import { routesConfig } from '../../../shared/onboardingConfig';
import { NEW_ATHLETE_FLOW } from '../../../shared/onboardingConstants';

import { useOnboardingContext } from '../../../state/OnboardingContext';

import CreateProfile from '../../steps/newAthleteFlow/CreateProfile';
import SuggestedFriends from '../../steps/newAthleteFlow/SuggestedFriends';
import FacebookFriends from '../../steps/newAthleteFlow/FacebookFriends';
import Welcome from '../../steps/newAthleteFlow/Welcome';
import SubscriptionTrial from '../../steps/newAthleteFlow/SubscriptionTrial/SubscriptionTrial';
import DirectPromotion from '../../steps/shared/DirectPromotion';

const NewAthleteFlowRoutes = () => {
  const { state } = useOnboardingContext();
  const { category } = state;

  return (
    <Switch>
      {/**
       * IMPORTANT - accounts registered using fb and google start the flow with
       * /apple_registered and /facebook_registered (and not /continue)
       *
       * These legacy routes are mapped to reuse the same step as /continue and
       * maintain underscore case by passing the flag isLegacyPath to stepToUrl.
       *
       * See - https://github.com/strava/active/blob/583a84e4d54bec7087d0a8ad5ebe8e762ad02a45/app/controllers/onboarding_controller.rb
       */}
      <Route
        path={[
          stepToUrl({ category, step: NEW_ATHLETE_FLOW.createProfile }),
          stepToUrl({
            category,
            step: NEW_ATHLETE_FLOW.facebookRegistered,
            isLegacyPath: true
          }),
          stepToUrl({
            category,
            step: NEW_ATHLETE_FLOW.googleRegistered,
            isLegacyPath: true
          })
        ]}
        {...routesConfig}
      >
        <CreateProfile />
      </Route>

      <Route
        path={stepToUrl({ category, step: NEW_ATHLETE_FLOW.suggestedFriends })}
        {...routesConfig}
      >
        <SuggestedFriends />
      </Route>

      <Route
        path={stepToUrl({ category, step: NEW_ATHLETE_FLOW.facebookFriends })}
        {...routesConfig}
      >
        <FacebookFriends />
      </Route>

      <Route
        path={stepToUrl({
          category,
          step: NEW_ATHLETE_FLOW.subscriptionTrial
        })}
        {...routesConfig}
      >
        <SubscriptionTrial />
      </Route>

      <Route
        path={stepToUrl({
          category,
          step: NEW_ATHLETE_FLOW.directPromotion
        })}
        {...routesConfig}
      >
        <DirectPromotion />
      </Route>

      <Route
        path={stepToUrl({ category, step: NEW_ATHLETE_FLOW.welcome })}
        {...routesConfig}
      >
        <Welcome />
      </Route>
    </Switch>
  );
};

export default NewAthleteFlowRoutes;
